// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%234a6cf7%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z%27%3E%3C/path%3E%3Cpolyline points=%279 22 9 12 15 12 15 22%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2338b2ac%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z%27%3E%3C/path%3E%3Cpolyline points=%2714 2 14 8 20 8%27%3E%3C/polyline%3E%3Cline x1=%2716%27 y1=%2713%27 x2=%278%27 y2=%2713%27%3E%3C/line%3E%3Cline x1=%2716%27 y1=%2717%27 x2=%278%27 y2=%2717%27%3E%3C/line%3E%3Cpolyline points=%2710 9 9 9 8 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2348bb78%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%279 11 12 14 22 4%27%3E%3C/polyline%3E%3Cpath d=%27M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23ed8936%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M22 11.08V12a10 10 0 1 1-5.93-9.14%27%3E%3C/path%3E%3Cpolyline points=%2722 4 12 14.01 9 11.01%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Test Suites Overview Styles */
.test-suites-overview-container {
  padding: 0;
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 0;
  margin: 0;
  overflow: visible;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.test-suites-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-shrink: 0;
}

.test-suites-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-dark);
  margin: 0;
}

.test-suites-subtitle {
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.test-suites-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

/* Stats Summary */
.stats-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0.75rem 0;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.stat-item {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1 1;
}

.stat-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 15%;
  height: 70%;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.06);
}

.stat-item::before {
  content: '';
  display: block;
  width: 32px;
  height: 32px;
  margin-bottom: 0.4rem;
  background-size: 20px;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
}

.stat-item:nth-child(1)::before {
  background-color: rgba(74, 108, 247, 0.1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.stat-item:nth-child(2)::before {
  background-color: rgba(56, 178, 172, 0.1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.stat-item:nth-child(3)::before {
  background-color: rgba(72, 187, 120, 0.1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.stat-item:nth-child(4)::before {
  background-color: rgba(237, 137, 54, 0.1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.stat-label {
  font-size: 0.7rem;
  color: var(--text-muted, #718096);
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-dark, #2d3748);
  margin: 0.3rem 0 0;
  line-height: 1;
}

/* Filters Row */
.filters-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-dropdown {
  display: flex;
  /* align-items: center; */
  align-self: start;
  gap: 0.5rem;
}

.filter-dropdown label {
  font-size: 0.8rem;
  color: var(--text-muted);
  white-space: nowrap;
}

.filter-select {
  padding: 0.35rem 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--border-color, #ccc);
  font-size: 0.8rem;
  min-width: 120px;
}

/* Search Box */
.search-box {
  flex: 1 1;
  max-width: 300px;
}

.search-box input {
  width: 100%;
  padding: 0.5rem;
  padding-left: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.8rem;
}

/* Projects List */
.projects-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}

.project-card {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  padding: 0.6rem 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

/* Let an expanded card shrink so its table scrolls instead of the page */
.project-card:has(.project-content.expanded) {
  flex-shrink: 1;
  min-height: 0;
}

.project-header {
  margin-bottom: 0;
}

.project-header-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  min-width: 0;
  flex-wrap: wrap;
}

.project-title-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.project-info {
  flex: 1 1;
  min-width: 0;
}

.project-name {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: var(--text-dark);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.project-name:hover {
  color: var(--primary-color, #007bff);
}

.project-status {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 500;
  padding: 0.15rem 0.35rem;
  border-radius: 10px;
  white-space: nowrap;
}

.project-status.status-active {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.project-status.status-inactive {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.project-status.status-completed {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
}

.project-status.status-archived {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.project-status.status-draft {
  background-color: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

.project-description {
  color: var(--text-muted);
  margin: 0;
  font-size: 0.8rem;
}

/* Project Header Stats */
.project-header-stats {
  display: flex;
  gap: 2rem;
  margin-right: 2rem;
}

.header-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}

.header-stat-label {
  font-size: 0.7rem;
  color: var(--text-muted, #718096);
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
}

.header-stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-dark, #2d3748);
  line-height: 1;
}

.header-stat-value.passed {
  color: #28a745;
}

.header-stat-value.failed {
  color: #dc3545;
}

.header-stat-value.pending {
  color: #ffc107;
}

/* Expand/Collapse Toggle */
.expand-toggle {
  background: none;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-muted);
}

.expand-toggle:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--primary-color, #007bff);
}

.expand-toggle.expanded svg {
  transform: rotate(180deg);
}

/* Project Content */
.project-content {
  display: none;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.project-content.expanded {
  display: flex;
  flex-direction: column;
  opacity: 1;
  height: auto;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Project Stats */
.project-stats {
  display: flex;
  gap: 1.25rem;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 0.7rem;
  color: var(--text-muted);
}

.stat-value {
  font-size: 0.9rem;
  font-weight: 600;
}

/* Test Suites Table */
.test-suites-table-container {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  padding: 0.75rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  max-width: 100%;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
}

/* Only the table rows scroll; header (sticky) and pagination stay fixed */
.table-scroll-area {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: auto;
}

.test-suites-table-container .pagination {
  flex-shrink: 0;
  margin-top: 0.5rem;
}

.test-suites-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.test-suites-table th,
.test-suites-table td {
  padding: 0.5rem 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color-light, #eee);
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-suites-table th:nth-child(1),
.test-suites-table td:nth-child(1) {
  width: 28%;
}

.test-suites-table th:nth-child(2),
.test-suites-table td:nth-child(2) {
  width: 10%;
  text-align: center;
}

.test-suites-table th:nth-child(3),
.test-suites-table td:nth-child(3) {
  width: 11%;
  text-align: center;
}

.test-suites-table th:nth-child(4),
.test-suites-table td:nth-child(4) {
  width: 15%;
  text-align: center;
}

.test-suites-table th.column-execution-history,
.test-suites-table td.column-execution-history {
  width: 14%;
  text-align: center;
  vertical-align: middle;
  overflow: visible;
}

.test-suites-table th {
    font-weight: 600;
  color: var(--text-dark);
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 1;
}

.test-suites-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.test-suite-name-cell {
  cursor: pointer;
  color: var(--primary-color, #007bff);
}

.test-suite-name-cell:hover {
  text-decoration: underline;
}

/* Pass Rate Badge */
.pass-rate-badge {
  display: inline-block;
  padding: 0.15rem 0.35rem;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
}

.pass-rate-badge.high {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.pass-rate-badge.medium {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.pass-rate-badge.low {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

/* Test Suite Actions */
.test-suites-table th.column-actions,
.test-suites-table td.column-actions {
  width: 22%;
  text-align: center;
  vertical-align: middle;
  padding: 0.5rem 0.5rem;
  overflow: visible;
  white-space: nowrap;
}

.test-suites-table th:nth-child(5),
.test-suites-table td:nth-child(5) {
  text-align: center;
}

.test-suites-table .column-actions .test-suite-action-buttons {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  vertical-align: middle;
  min-width: 0;
  max-width: 100%;
  margin-left: 3.5rem;
}

.test-suites-table .column-actions .test-suite-action-buttons .action-btn {
  flex-shrink: 0;
  background: none;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
  width: 26px;
  height: 26px;
  min-width: 26px;
  min-height: 26px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-muted);
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  line-height: 0;
  font-size: 0;
  box-sizing: border-box;
}

.test-suites-table .column-actions .test-suite-action-buttons .action-btn svg {
  width: 14px;
  height: 14px;
  display: block;
  flex-shrink: 0;
  pointer-events: none;
}

.test-suites-table .column-actions .test-suite-action-buttons .action-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.08);
}

.test-suites-table .column-actions .test-suite-action-buttons .action-btn.edit:hover {
  color: var(--primary-color, #007bff);
}

.test-suites-table .column-actions .test-suite-action-buttons .action-btn.delete:hover:not(:disabled) {
  color: #dc3545;
}

.test-suites-table .column-actions .test-suite-action-buttons .action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.test-suites-table .column-actions .test-suite-action-buttons .action-btn.link:hover {
  color: #17a2b8;
}

.test-suites-table .column-actions .test-suite-action-buttons .action-btn.unlink:hover {
  color: #fd7e14;
}

/* Project Footer */
.project-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 0.5rem;
  flex-shrink: 0;
}

/* Keep the projects pagination visible at the bottom of the page */
.test-suites-overview-container > .pagination {
  flex-shrink: 0;
  margin-top: 0.5rem;
}

.btn {
  padding: 0.375rem 0.75rem;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.btn-primary {
  background-color: var(--primary-color, #007bff);
  color: white;
  border-color: var(--primary-color, #007bff);
}

.btn-primary:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}

/* Action Feedback */
.action-feedback {
  position: fixed;
  top: 1rem;
  right: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 1000;
  animation: slideIn 0.3s ease;
}

.action-feedback.success {
  border-left: 4px solid #28a745;
}

.action-feedback.error {
  border-left: 4px solid #dc3545;
}

.action-feedback.info {
  border-left: 4px solid #17a2b8;
}

.action-feedback button {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: var(--text-muted);
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Loading and Error States */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: var(--primary-color, #007bff);
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.error-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .test-suites-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .test-suites-actions {
    width: 100%;
  }

  .filters-row {
    flex-wrap: wrap;
  }
  
  .search-box {
    max-width: 100%;
    width: 100%;
    margin-bottom: 0.5rem;
  }
  
  .filter-dropdown {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: calc(50% - 0.5rem);
  }
  
  .stats-summary {
    flex-wrap: wrap;
  }
  
  .stat-item {
    flex: 1 0 40%;
    margin-bottom: 1rem;
  }
}

@media (max-width: 576px) {
  .filter-dropdown {
    flex: 1 0 100%;
  }
  
  .project-header-main {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .project-header-stats {
    margin: 1rem 0;
    width: 100%;
    justify-content: space-between;
    gap: 1rem;
  }
  
  .header-stat {
    min-width: auto;
  }
  
  .expand-toggle {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
  
  .project-card {
    position: relative;
  }
}
.table-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 200px;
}

.table-loader .loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Execution History column */
.test-suites-table .column-execution-history {
  text-align: center;
  white-space: nowrap;
}

.test-suites-table .column-execution-history .action-btn.execution-history {
  background: none;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-muted, #6c757d);
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  line-height: 0;
}

.test-suites-table .column-execution-history .action-btn.execution-history:hover {
  background-color: rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.08);
  color: var(--primary-color, #007bff);
}

.test-suites-table .column-execution-history .action-btn.execution-history svg {
  width: 16px;
  height: 16px;
  display: block;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/test-suites-overview.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,yDAAgX;AAClX;;AAEA;EACE,yCAAyC;EACzC,yDAAghB;AAClhB;;AAEA;EACE,yCAAyC;EACzC,yDAAqX;AACvX;;AAEA;EACE,yCAAyC;EACzC,yDAAoW;AACtW;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,0EAA0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,wDAAwD;EACxD,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;;EAEE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,+EAA+E;EAC/E,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,+CAA+C;EAC/C,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,+EAA+E;EAC/E,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB","sourcesContent":["/* Test Suites Overview Styles */\n.test-suites-overview-container {\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  min-height: 0;\n  margin: 0;\n  overflow: visible;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.test-suites-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-shrink: 0;\n}\n\n.test-suites-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-dark);\n  margin: 0;\n}\n\n.test-suites-subtitle {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n.test-suites-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n/* Stats Summary */\n.stats-summary {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  padding: 0.75rem 0;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  flex-shrink: 0;\n}\n\n.stat-item {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  flex: 1;\n}\n\n.stat-item:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 15%;\n  height: 70%;\n  width: 1px;\n  background-color: rgba(0, 0, 0, 0.06);\n}\n\n.stat-item::before {\n  content: '';\n  display: block;\n  width: 32px;\n  height: 32px;\n  margin-bottom: 0.4rem;\n  background-size: 20px;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 50%;\n}\n\n.stat-item:nth-child(1)::before {\n  background-color: rgba(74, 108, 247, 0.1);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%234a6cf7' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'%3E%3C/path%3E%3Cpolyline points='9 22 9 12 15 12 15 22'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.stat-item:nth-child(2)::before {\n  background-color: rgba(56, 178, 172, 0.1);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2338b2ac' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'%3E%3C/path%3E%3Cpolyline points='14 2 14 8 20 8'%3E%3C/polyline%3E%3Cline x1='16' y1='13' x2='8' y2='13'%3E%3C/line%3E%3Cline x1='16' y1='17' x2='8' y2='17'%3E%3C/line%3E%3Cpolyline points='10 9 9 9 8 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.stat-item:nth-child(3)::before {\n  background-color: rgba(72, 187, 120, 0.1);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2348bb78' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='9 11 12 14 22 4'%3E%3C/polyline%3E%3Cpath d='M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'%3E%3C/path%3E%3C/svg%3E\");\n}\n\n.stat-item:nth-child(4)::before {\n  background-color: rgba(237, 137, 54, 0.1);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23ed8936' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M22 11.08V12a10 10 0 1 1-5.93-9.14'%3E%3C/path%3E%3Cpolyline points='22 4 12 14.01 9 11.01'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.stat-label {\n  font-size: 0.7rem;\n  color: var(--text-muted, #718096);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.stat-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-dark, #2d3748);\n  margin: 0.3rem 0 0;\n  line-height: 1;\n}\n\n/* Filters Row */\n.filters-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.filter-dropdown {\n  display: flex;\n  /* align-items: center; */\n  align-self: start;\n  gap: 0.5rem;\n}\n\n.filter-dropdown label {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.filter-select {\n  padding: 0.35rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid var(--border-color, #ccc);\n  font-size: 0.8rem;\n  min-width: 120px;\n}\n\n/* Search Box */\n.search-box {\n  flex: 1;\n  max-width: 300px;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 0.5rem;\n  padding-left: 0.75rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.8rem;\n}\n\n/* Projects List */\n.projects-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.project-card {\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  padding: 0.6rem 1rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n/* Let an expanded card shrink so its table scrolls instead of the page */\n.project-card:has(.project-content.expanded) {\n  flex-shrink: 1;\n  min-height: 0;\n}\n\n.project-header {\n  margin-bottom: 0;\n}\n\n.project-header-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.project-title-section {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.project-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.project-name {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--text-dark);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.project-name:hover {\n  color: var(--primary-color, #007bff);\n}\n\n.project-status {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 500;\n  padding: 0.15rem 0.35rem;\n  border-radius: 10px;\n  white-space: nowrap;\n}\n\n.project-status.status-active {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.project-status.status-inactive {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.project-status.status-completed {\n  background-color: rgba(23, 162, 184, 0.1);\n  color: #17a2b8;\n}\n\n.project-status.status-archived {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.project-status.status-draft {\n  background-color: rgba(108, 117, 125, 0.1);\n  color: #6c757d;\n}\n\n.project-description {\n  color: var(--text-muted);\n  margin: 0;\n  font-size: 0.8rem;\n}\n\n/* Project Header Stats */\n.project-header-stats {\n  display: flex;\n  gap: 2rem;\n  margin-right: 2rem;\n}\n\n.header-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 60px;\n}\n\n.header-stat-label {\n  font-size: 0.7rem;\n  color: var(--text-muted, #718096);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  margin-bottom: 0.25rem;\n}\n\n.header-stat-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-dark, #2d3748);\n  line-height: 1;\n}\n\n.header-stat-value.passed {\n  color: #28a745;\n}\n\n.header-stat-value.failed {\n  color: #dc3545;\n}\n\n.header-stat-value.pending {\n  color: #ffc107;\n}\n\n/* Expand/Collapse Toggle */\n.expand-toggle {\n  background: none;\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: var(--text-muted);\n}\n\n.expand-toggle:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: var(--primary-color, #007bff);\n}\n\n.expand-toggle.expanded svg {\n  transform: rotate(180deg);\n}\n\n/* Project Content */\n.project-content {\n  display: none;\n  opacity: 0;\n  height: 0;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.project-content.expanded {\n  display: flex;\n  flex-direction: column;\n  opacity: 1;\n  height: auto;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Project Stats */\n.project-stats {\n  display: flex;\n  gap: 1.25rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-label {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n}\n\n.stat-value {\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n/* Test Suites Table */\n.test-suites-table-container {\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  padding: 0.75rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  max-width: 100%;\n  margin-bottom: 0.5rem;\n  box-sizing: border-box;\n}\n\n/* Only the table rows scroll; header (sticky) and pagination stay fixed */\n.table-scroll-area {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.test-suites-table-container .pagination {\n  flex-shrink: 0;\n  margin-top: 0.5rem;\n}\n\n.test-suites-table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n.test-suites-table th,\n.test-suites-table td {\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color-light, #eee);\n  font-size: 0.8rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.test-suites-table th:nth-child(1),\n.test-suites-table td:nth-child(1) {\n  width: 28%;\n}\n\n.test-suites-table th:nth-child(2),\n.test-suites-table td:nth-child(2) {\n  width: 10%;\n  text-align: center;\n}\n\n.test-suites-table th:nth-child(3),\n.test-suites-table td:nth-child(3) {\n  width: 11%;\n  text-align: center;\n}\n\n.test-suites-table th:nth-child(4),\n.test-suites-table td:nth-child(4) {\n  width: 15%;\n  text-align: center;\n}\n\n.test-suites-table th.column-execution-history,\n.test-suites-table td.column-execution-history {\n  width: 14%;\n  text-align: center;\n  vertical-align: middle;\n  overflow: visible;\n}\n\n.test-suites-table th {\n    font-weight: 600;\n  color: var(--text-dark);\n  background-color: #f8f9fa;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.test-suites-table tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n.test-suite-name-cell {\n  cursor: pointer;\n  color: var(--primary-color, #007bff);\n}\n\n.test-suite-name-cell:hover {\n  text-decoration: underline;\n}\n\n/* Pass Rate Badge */\n.pass-rate-badge {\n  display: inline-block;\n  padding: 0.15rem 0.35rem;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.pass-rate-badge.high {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.pass-rate-badge.medium {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n.pass-rate-badge.low {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n/* Test Suite Actions */\n.test-suites-table th.column-actions,\n.test-suites-table td.column-actions {\n  width: 22%;\n  text-align: center;\n  vertical-align: middle;\n  padding: 0.5rem 0.5rem;\n  overflow: visible;\n  white-space: nowrap;\n}\n\n.test-suites-table th:nth-child(5),\n.test-suites-table td:nth-child(5) {\n  text-align: center;\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: nowrap;\n  vertical-align: middle;\n  min-width: 0;\n  max-width: 100%;\n  margin-left: 3.5rem;\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons .action-btn {\n  flex-shrink: 0;\n  background: none;\n  border: 1px solid transparent;\n  padding: 0;\n  margin: 0;\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  min-height: 26px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-muted);\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  line-height: 0;\n  font-size: 0;\n  box-sizing: border-box;\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons .action-btn svg {\n  width: 14px;\n  height: 14px;\n  display: block;\n  flex-shrink: 0;\n  pointer-events: none;\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons .action-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  border-color: rgba(0, 0, 0, 0.08);\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons .action-btn.edit:hover {\n  color: var(--primary-color, #007bff);\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons .action-btn.delete:hover:not(:disabled) {\n  color: #dc3545;\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons .action-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons .action-btn.link:hover {\n  color: #17a2b8;\n}\n\n.test-suites-table .column-actions .test-suite-action-buttons .action-btn.unlink:hover {\n  color: #fd7e14;\n}\n\n/* Project Footer */\n.project-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 0.5rem;\n  flex-shrink: 0;\n}\n\n/* Keep the projects pagination visible at the bottom of the page */\n.test-suites-overview-container > .pagination {\n  flex-shrink: 0;\n  margin-top: 0.5rem;\n}\n\n.btn {\n  padding: 0.375rem 0.75rem;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n}\n\n.btn-primary {\n  background-color: var(--primary-color, #007bff);\n  color: white;\n  border-color: var(--primary-color, #007bff);\n}\n\n.btn-primary:hover {\n  background-color: #0069d9;\n  border-color: #0062cc;\n}\n\n/* Action Feedback */\n.action-feedback {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  background-color: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  z-index: 1000;\n  animation: slideIn 0.3s ease;\n}\n\n.action-feedback.success {\n  border-left: 4px solid #28a745;\n}\n\n.action-feedback.error {\n  border-left: 4px solid #dc3545;\n}\n\n.action-feedback.info {\n  border-left: 4px solid #17a2b8;\n}\n\n.action-feedback button {\n  background: none;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  color: var(--text-muted);\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Loading and Error States */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top-color: var(--primary-color, #007bff);\n  animation: spin 1s ease-in-out infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.error-icon {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .test-suites-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .test-suites-actions {\n    width: 100%;\n  }\n\n  .filters-row {\n    flex-wrap: wrap;\n  }\n  \n  .search-box {\n    max-width: 100%;\n    width: 100%;\n    margin-bottom: 0.5rem;\n  }\n  \n  .filter-dropdown {\n    flex: 1 0 calc(50% - 0.5rem);\n  }\n  \n  .stats-summary {\n    flex-wrap: wrap;\n  }\n  \n  .stat-item {\n    flex: 1 0 40%;\n    margin-bottom: 1rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .filter-dropdown {\n    flex: 1 0 100%;\n  }\n  \n  .project-header-main {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .project-header-stats {\n    margin: 1rem 0;\n    width: 100%;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n  \n  .header-stat {\n    min-width: auto;\n  }\n  \n  .expand-toggle {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n  }\n  \n  .project-card {\n    position: relative;\n  }\n}\n.table-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  min-height: 200px;\n}\n\n.table-loader .loading-spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Execution History column */\n.test-suites-table .column-execution-history {\n  text-align: center;\n  white-space: nowrap;\n}\n\n.test-suites-table .column-execution-history .action-btn.execution-history {\n  background: none;\n  border: 1px solid transparent;\n  padding: 0;\n  margin: 0;\n  width: 26px;\n  height: 26px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-muted, #6c757d);\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  line-height: 0;\n}\n\n.test-suites-table .column-execution-history .action-btn.execution-history:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  border-color: rgba(0, 0, 0, 0.08);\n  color: var(--primary-color, #007bff);\n}\n\n.test-suites-table .column-execution-history .action-btn.execution-history svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
